import { selectVariant } from 'shared/product_tabs/tab_stencils/slice/utils/selectVariant';

export const changeParametersForStencil = (state, name, value, ref) => {
  const stencil = state.stencils[ref];
  stencil.parameters[name] = value;

  const { parameters } = stencil;
  const variants = stencil.product.variants.filter((v) => v.option_values.length === stencil.product.option_types.length);
  const newVariant = selectVariant(parameters, variants);

  if (newVariant && stencil.variant && stencil.variant.id !== newVariant.id) {
    state.stencilsToDestroy.push(stencil.line_item_id);
  }

  stencil.variant = newVariant;
  const foundIndex = state.stencilsToBuy.findIndex((s) => s.parameters.stencil_side === stencil.parameters.stencil_side);
  if (foundIndex >= 0) {
    state.stencilsToBuy[foundIndex] = _.cloneDeep(stencil);
  }
};
